import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type ToggleOptimizationDto = ClientInferResponseBody<typeof contract.optimizations.toggle>;

export const toggleOptimization = async ({
  optimizationId,
  enabled,
}: {
  optimizationId: string;
  enabled: boolean;
}): Promise<ToggleOptimizationDto> => {
  const response = await api.optimizations.toggle.mutation({
    params: { id: optimizationId },
    body: { enabled },
  });

  if (response.status !== 200) {
    throw new ApiError("Error toggling optimization", response.status, response.body);
  }

  return response.body;
};
